import { Component, OnInit, inject, input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { finalize } from 'rxjs';
import { InfoboxService } from '@/common/infobox/infobox.service';
import { LoaderService } from '@/common/loader/loader.service';
import { ReservationApiService } from '../reservation.api.service';
import { ReservationRefundRecipientPayload } from '../reservation.model';

@Component({
	selector: 'app-reservation-refund-data',
	templateUrl: './reservation-refund-data.component.html',
	styleUrls: ['./reservation-refund-data.component.scss'],
})
export class ReservationRefundDataComponent implements OnInit {
	readonly reservationId = input.required<number>();

	readonly refundDataForm = new FormGroup({
		firstName: new FormControl(''),
		lastName: new FormControl(''),
		bankAccount: new FormControl(''),
	});

	private refundRecipientId: number | null = null;

	private readonly apiService = inject(ReservationApiService);
	private readonly infobox = inject(InfoboxService);
	private readonly loader = inject(LoaderService);

	ngOnInit(): void {
		this.loader.show();
		this.apiService
			.getRefundRecipient(this.reservationId())
			.pipe(finalize(() => this.loader.hide()))
			.subscribe((recipient) => {
				if (!recipient) {
					return;
				}
				this.refundRecipientId = recipient.id;
				this.refundDataForm.patchValue({
					firstName: recipient.firstName,
					lastName: recipient.lastName,
					bankAccount: recipient.bankAccount,
				});
			});
	}

	save(): void {
		const payload: ReservationRefundRecipientPayload = {
			firstName: this.refundDataForm.value.firstName ?? '',
			lastName: this.refundDataForm.value.lastName ?? '',
			bankAccount: this.refundDataForm.value.bankAccount ?? '',
		};

		this.loader.show();
		const request$ = this.refundRecipientId
			? this.apiService.updateRefundRecipient(this.reservationId(), payload)
			: this.apiService.createRefundRecipient(this.reservationId(), payload);

		request$.pipe(finalize(() => this.loader.hide())).subscribe((recipient) => {
			this.refundRecipientId = recipient.id;
			this.infobox.success('Dane do zwrotów zostały zapisane');
		});
	}
}
